var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 20V32H30.9981L31 35L26 32H22V20H34ZM26 16V19H24V18H16V26H21V28.6L17 31L17.0019 28H14V16H26ZM32 22H24V30H32V22ZM28.5875 23L30.857 29H29.7392L29.1209 27.2809H26.8683L26.2543 29H25.2L27.4188 23H28.5875ZM27.9946 24.0035C27.9134 24.2881 27.8061 24.6168 27.6727 24.9898L27.6559 25.0367L27.152 26.4594H28.833L28.3291 25.0367L28.285 24.9094C28.1821 24.6094 28.0853 24.3074 27.9946 24.0035ZM20.4858 18.619V19.119H21L21 22.8071C20.9302 22.9416 20.8554 23.0735 20.776 23.2026C20.849 23.267 20.9237 23.3296 21 23.3902V24.6206C20.693 24.4199 20.4163 24.2133 20.1699 24.0009C19.4874 24.7217 18.5577 25.2326 17.3929 25.5353L17.0944 25.6071L16.8774 24.6309C18.0146 24.3783 18.8737 23.9286 19.4709 23.2842C18.9272 22.618 18.543 21.865 18.3204 21.0293L18.247 20.724L19.2247 20.514C19.3768 21.222 19.6582 21.8576 20.0707 22.425C20.4425 21.7378 20.6586 20.9707 20.7186 20.119H16.9859V19.119H19.4859V18.619H20.4858Z",
    fill: "#1B2559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguages);
export default __webpack_public_path__ + "static/media/Languages.ee78a9fc88c8e9fe870fb30cce9cedbf.svg";
export { ForwardRef as ReactComponent };